import { Result, Row } from "antd";
import React from "react";

const DeactivatedPage = () => {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Result
        status="error"
        title="Reporte Desactivado"
        subTitle="El reporte se ha desactivado."
      />
    </div>
  );
};

export default DeactivatedPage;
